import "@esri/calcite-components/components/calcite-loader";
import ThumbNail from "../../../assets/images/ThumbNail.png";
import "@esri/calcite-components/components/calcite-block";
import "@esri/calcite-components/components/calcite-card";
import "@esri/calcite-components/components/calcite-button";
import "@esri/calcite-components/components/calcite-link";
import InsertBuilding from "./insertbuilding/InsertBuilding.js";

import texts from "../../../assets/texts/texts.js";

function SampleModel({ onChange }) {
  const insertBuilding = new InsertBuilding();
  const url = "./models/sample_building.glb";
  const handleDownload = async () => {
    const res = await fetch(url);

    if (!res.ok) throw new Error(`Download failed: ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = "sample_building.glb"; // jak se má uložit
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  };

  const handlePlacemodel = async () => {
    const mesh = await insertBuilding.fromSample();
    onChange(mesh);
  };

  return (
    <>
      <calcite-block
        scale="l"
        collapsible
        heading={texts.widgets.uploadmodel.sampleModel.title}
        icon-start="3d-building"
      >
        <calcite-panel>
          <calcite-card id="samplemodelCard">
            <img
              id="sampleThumbnail"
              slot="thumbnail"
              alt="Sample image alt"
              src={ThumbNail}
            />
            <span slot="heading">
              {texts.widgets.uploadmodel.sampleModel.title} - 147.5 m{" "}
            </span>
            <span slot="description" id="sampDescription">
              {texts.widgets.uploadmodel.sampleModel.paragraph_1}

              <calcite-link
                slot="link"
                href="https://studio.blender.org/"
                target="_blank"
              >
                blender
              </calcite-link>
              {texts.widgets.uploadmodel.sampleModel.paragraph_2 + " "}

              <calcite-link
                slot="link"
                href={texts.widgets.uploadmodel.sampleModel.descriptionsURL}
                target="_blank"
              >
                {texts.description}:{" "}
                {texts.widgets.uploadmodel.sampleModel.title}
              </calcite-link>
            </span>
          </calcite-card>
          <calcite-button
            slot="footer"
            icon-start="pin"
            width="half"
            id="placeModelButton"
            label={texts.widgets.uploadmodel.sampleModel.place}
            target="_blank"
            appearance="outline"
            onClick={handlePlacemodel}
          >
            {texts.widgets.uploadmodel.sampleModel.place}
          </calcite-button>

          <calcite-button
            slot="footer"
            icon-start="download"
            width="half"
            onClick={handleDownload}
            label={texts.widgets.uploadmodel.sampleModel.download}
          >
            {texts.widgets.uploadmodel.sampleModel.download}
          </calcite-button>
        </calcite-panel>
      </calcite-block>
    </>
  );
}

export default SampleModel;
